export * from './homepage-menu-config';
